class ProductRecently extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('[data-product-recently]');
    this.slidable = this.dataset.slidable;
    const handle = this.dataset.handle;
    const limit = this.dataset.limit;
    if (this.slidable === 'true') {
      this.slider = this.querySelector('slider-component');
    }
    if (handle !== '' && handle !== undefined) {
      this.add(handle, limit);
      this.show(handle);
    }
  }

  add(handle, limit) {
    let data = localStorage.getItem('product-recently');
    if (data !== null && data !== '[]' && data !== '[null]') {
      data = JSON.parse(data);
    } else {
      data = [];
    }
    const index = data.indexOf(handle);
    if (index !== -1) {
      data.splice(index, 1);
    }
    data.push(handle);
    if (data.length > parseInt(limit, 10) + 1) {
      const begin = data.length - (parseInt(limit, 10) + 1);
      data = data.slice(begin);
    }
    localStorage.setItem('product-recently', JSON.stringify(data));
  }

  removeStaleHandle(handle) {
    const data = localStorage.getItem('product-recently');
    if (data === null) return;
    try {
      const list = JSON.parse(data).filter((item) => item !== handle);
      localStorage.setItem('product-recently', JSON.stringify(list));
    } catch (e) {
      console.error(e);
    }
  }

  show(handle) {
    const session = localStorage.getItem('product-recently');
    if (session !== null && session !== '[]' && session !== '[null]') {
      const products = JSON.parse(session);
      if (products.length == 1) {
        this.classList.add('hidden');
      }
      this.content.classList.add('is-loading');
      this.showContent(products, handle);
    }
  }

  async showContent(products, handle) {
    const targets = products.filter((item) => item && item !== handle);
    const finish = () => {
      this.content.classList.remove('is-loading');
      if (this.slidable === 'true' && this.slider) {
        this.slider.init();
      }
    };

    if (targets.length === 0) {
      finish();
      return;
    }

    for (const [i, productHandle] of targets.entries()) {
      const url = `/products/${productHandle}?view=item`;
      try {
        const html = await new Promise((resolve, reject) => {
          $.get(url).done(resolve).fail(reject);
        });

        // Shopify can return the full storefront page (instead of just
        // the item fragment) if the product no longer exists/isn't
        // published, or a cache serves the wrong response for this URL.
        // Only insert what we actually asked for, and drop the handle
        // from localStorage so a stale product isn't retried forever.
        const parsed = document.createElement('div');
        parsed.innerHTML = html;
        const fragment = parsed.querySelector('.product-item__grid');
        if (!fragment) {
          this.removeStaleHandle(productHandle);
          continue;
        }

        if (this.slidable === 'true') {
          $(`<div class="swiper-slide col product-item__content product-item__content-${i}" data-carousel-item></div>`).appendTo($(this.content));
        } else {
          $(`<div class="col product-item__content product-item__content-${i}"></div>`).appendTo($(this.content));
        }
        const innerHTML = find(`.product-item__content-${i}`, this.content);
        $(innerHTML).append(fragment);
      } catch (e) {
        console.error(e);
      }
    }

    finish();
  }
}

customElements.define('product-recently', ProductRecently);
